const products_on_page = document.getElementById("product-grid");
const nextUrl = document.getElementById("paginateNext");
let next_url = nextUrl.dataset.nextUrl;
const productsPerPage = parseInt(nextUrl.dataset.productsPerPage) || 36; // Default to 36 if not set

const load_more_btn = document.getElementsByClassName("load-more_btn")[0];
const button_text = load_more_btn.querySelector(".button-text");
const load_more_spinner = load_more_btn.querySelector(".loading__spinner");

async function getNextPage() {
  try {
    // Ensure the URL includes the correct page size
    const url = new URL(next_url, window.location.origin);
    const currentParams = new URLSearchParams(url.search);

    // Update or add the page_size parameter
    if (!currentParams.has("page_size")) {
      url.searchParams.set("page_size", productsPerPage);
    }

    let res = await fetch(url.toString());
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  button_text.style.display = "none";
  load_more_spinner.classList.remove("hidden");
  let nextPage = await getNextPage();

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, "text/html");

  load_more_spinner.classList.add("hidden");
  button_text.style.display = "inline";

  const productgrid = nextPageDoc.getElementById("product-grid");
  const new_products = productgrid.getElementsByClassName("grid__item");
  const newUrl = nextPageDoc.getElementById("paginateNext");
  const new_url = newUrl?.dataset.nextUrl;

  // Check if we got the expected number of products
  console.log(
    `Loaded ${new_products.length} products of ${productsPerPage} expected`
  );

  // Hide load more button if we've reached the end of products
  if (!new_url || new_products.length < productsPerPage) {
    load_more_btn.style.display = "none";
  }

  next_url = new_url;
  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }

  // Initialize all product features for new products
  initializeNewProducts();
}

// Function to initialize all features for newly added products
function initializeNewProducts() {
  // Initialize carousels
  const newCarousels = document.querySelectorAll(
    ".card__media-carousel:not(.initialized)"
  );
  newCarousels.forEach((carousel) => {
    carousel.classList.add("initialized");
    new ProductCardCarousel(carousel);
  });

  // Initialize swatches using the existing functionality
  const newSwatches = document.querySelectorAll(
    ".card-swatch:not(.initialized)"
  );
  newSwatches.forEach((swatch) => {
    swatch.classList.add("initialized");
    swatch.addEventListener("click", function (event) {
      event.preventDefault();

      const cardWrapper = swatch.closest(".product-card-wrapper");
      const cardSwatches = cardWrapper.querySelectorAll(".swatch-container");
      cardSwatches.forEach((sw) => sw.classList.remove("active-swatch"));
      swatch.closest(".swatch-container").classList.add("active-swatch");

      const productUrl = swatch.getAttribute("data-url");
      const handle = productUrl.split("/products/")[1];
      const productId = swatch.getAttribute("data-id");
      const variantId = swatch.getAttribute("data-variant-id");
      const badgeValue = swatch.getAttribute("data-badge");
      const label = swatch.getAttribute("data-label");

      // Use the window-level fetchProductData function from swap-swatch.js
      window.fetchProductData(
        handle,
        cardWrapper,
        badgeValue,
        productId,
        variantId,
        label
      );
    });
  });

  // Initialize quick add functionality
  setupQuickAdd();

  // Reinitialize cart manager for new products
  if (window.cartManager) {
    window.cartManager.initializeEventListeners();
  }

  // Dispatch a custom event to notify other scripts
  document.dispatchEvent(new CustomEvent("products:loaded"));
}
